import React from 'react';
import ReactModal from "react-modal";

import {StandardButton} from "../button/standard-button/StandardButton";

export const ConfirmDeleteModal = ({
                                       showModal,
                                       setShowModal,
                                       onDeleteClick,
                                       titleToDelete,
                                   }) => {

    ReactModal.setAppElement('#root');

    const handleClose = () => {
        setShowModal(false);
    }

    return (
        <ReactModal isOpen={showModal} className="modal-content-t" overlayClassName="modal-overlay">
            <p className={"modal-header-delete-confirm"}>Are you sure you want to delete: {titleToDelete}?</p>
            <div className={"modal-button-group"}>
                <div className={"modal-button-group-mid"}>
                    <StandardButton onClick={handleClose} text={"Cancel"}/>
                    <StandardButton onClick={onDeleteClick} text={"Delete"}/>
                </div>
            </div>
        </ReactModal>
    );
}
